var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.666626C4.39166 0.666626 0.666664 4.39163 0.666664 8.99996C0.666664 13.6083 4.39166 17.3333 9 17.3333C13.6083 17.3333 17.3333 13.6083 17.3333 8.99996C17.3333 4.39163 13.6083 0.666626 9 0.666626ZM13.1667 11.9916L11.9917 13.1666L9 10.175L6.00833 13.1666L4.83333 11.9916L7.825 8.99996L4.83333 6.00829L6.00833 4.83329L9 7.82496L11.9917 4.83329L13.1667 6.00829L10.175 8.99996L13.1667 11.9916Z",
    fill: "#A40000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.666626C4.39166 0.666626 0.666664 4.39163 0.666664 8.99996C0.666664 13.6083 4.39166 17.3333 9 17.3333C13.6083 17.3333 17.3333 13.6083 17.3333 8.99996C17.3333 4.39163 13.6083 0.666626 9 0.666626ZM13.1667 11.9916L11.9917 13.1666L9 10.175L6.00833 13.1666L4.83333 11.9916L7.825 8.99996L4.83333 6.00829L6.00833 4.83329L9 7.82496L11.9917 4.83329L13.1667 6.00829L10.175 8.99996L13.1667 11.9916Z",
    fill: "#A40000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.b7f27615209e55a9ab621be1a1e00d58.svg";
export { ForwardRef as ReactComponent };